import { timestampDate } from '@bufbuild/protobuf/wkt';
import { ListMetricsResponse } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/aqora_service_pb';
import { MetricType } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/metrics_pb';
import { KpiModel } from '~/pages/Dashboard/models/KpiModel';
import { getRoundedUsage } from '~/pages/Dashboard/utils/kpi-calculations';
import { assertIsDefined } from '~/types/assert-type';

export class WaterStoredKpiModel {
  private kpiByType = new Map<MetricType, KpiModel>();

  constructor(private metricsResponse: ListMetricsResponse) {
    for (const metric of this.metricsResponse.metrics) {
      this.kpiByType.set(metric.type, this.createKpiModel(metric.type));
    }
  }

  private getDataPoint(metricType: MetricType) {
    const metric = this.metricsResponse.metrics.find(
      ({ type }) => type === metricType,
    );

    assertIsDefined(metric);

    if (!metric.dataPoints || metric.dataPoints.length === 0) {
      return undefined;
    }

    return metric.dataPoints[0];
  }

  private createKpiModel(type: MetricType) {
    let value;
    let timestamp;
    const dataPoint = this.getDataPoint(type);

    if (dataPoint) {
      const roundedUsage = getRoundedUsage(dataPoint);
      value = roundedUsage > 0 ? roundedUsage : 0;
      timestamp = dataPoint.timestamp;
    }

    return new KpiModel(type, value, timestamp && timestampDate(timestamp));
  }

  getWaterStoredKpi() {
    const kpi = this.kpiByType.get(MetricType.KPI_V2_WATER_STORED_L);
    assertIsDefined(kpi);

    return kpi;
  }
}
